<template>
    <div>
        <encabezado-filtros
            titulo="Visitas"
            :subtitulo="`${visitas.length} visitas registradas`"
            v-model:busqueda="busqueda"
            placeholder-busqueda="Buscar"
        >
            <template v-slot:acciones>
                <v-btn color="primary" to="/registrar-visita">
                    <v-icon start>mdi-check-circle-outline</v-icon>
                    Registrar visita
                </v-btn>
            </template>

            <template v-slot:filtros>
                <periodo-busqueda @buscar="onBuscar"/>
            </template>
        </encabezado-filtros>

        <v-card variant="outlined" rounded="lg">
            <v-data-table
            :loading="cargando"
            :headers="encabezadoTabla"
            :items="visitas"
            :search="busqueda"
            sort-by="nombre"
            :footer-props="{itemsPerPageText: 'Por página'}"
            >
                <template v-slot:[`item.nombre`]="{ item }">
                    <div class="d-flex align-center py-1" style="gap: 12px">
                        <v-avatar size="38">
                            <v-img v-if="item.imagen" :src="urlImagen(item.imagen)" alt="Foto"></v-img>
                            <v-icon v-else>mdi-account</v-icon>
                        </v-avatar>
                        <div>
                            <div class="font-weight-medium">{{ item.nombre }}</div>
                            <div class="text-caption text-muted">Matrícula {{ item.matricula }}</div>
                        </div>
                    </div>
                </template>

                <template v-slot:no-data>
                    <v-alert color="error" icon="warning">
                        No se han encontrado datos :(
                    </v-alert>
                    </template>
            </v-data-table>
        </v-card>

        <cartas-totales v-if="visitas.length > 0" class="mt-3" :totales="totalesMembresias" :titulo="'Visitas registradas por membresía'" :icono="'mdi-wallet-membership'" :color="'deep-purple accent-4'" />
        <cartas-totales v-if="visitas.length > 0" class="mt-3" :totales="totalesUsuarios" :titulo="'Visitas registradas por usuarios'" :icono="'mdi-badge-account'" :color="'brown darken-4'" />
        <cartas-totales-miembros v-if="visitas.length > 0" class="mt-3" :totales="totalesMiembros" :titulo="'Miembros con ,mayores visitas'"  />

    </div>
</template>
<script>
import HttpService from '../../Servicios/HttpService'
import Utiles from '../../Servicios/Utiles'
import PeriodoBusqueda from  '../Dialogos/PeriodoBusqueda.vue'
import CartasTotales from  '../Dialogos/CartasTotales.vue'
import CartasTotalesMiembros from  '../Dialogos/CartasTotalesMiembros.vue'
import EncabezadoFiltros from '../Dialogos/EncabezadoFiltros.vue'

export default {
    name: "Visitas",
    components: { PeriodoBusqueda, CartasTotales, CartasTotalesMiembros, EncabezadoFiltros },

    data:()=>({
        busqueda: "",
        cargando: false,
        visitas: [],
        encabezadoTabla: [
            {title: "Miembro", sortable: true, key: "nombre"},
            {title: "Fecha", sortable: true, key: "fecha"},
            {title: "Membresía ", sortable: true, key: "membresia"},
            {title: "Usuario", sortable: true, key: "usuario"},
            ],
        filtros: {
            fechaInicio: null,
            fechaFin: null
        },
        totalesMembresias: [],
        totalesUsuarios: [],
        totalesMiembros: []
    }),

    mounted(){
        this.obtenerVisitas()
    },

    methods: {
        onBuscar(fechas){
            this.filtros = {
                fechaInicio: fechas[0],
                fechaFin: fechas[1]
            }

            this.obtenerVisitas()
        },

        urlImagen(imagen){
            return Utiles.generarURL(imagen)
        },

        obtenerVisitas(){
            this.cargando = true
            let payload = {
                metodo: 'obtener',
                filtros: this.filtros
            }
            HttpService.obtenerConDatos(payload, 'visitas.php')
            .then(respuesta => {
                this.visitas = respuesta.visitas
                this.totalesMembresias = respuesta.totalesMembresias
                this.totalesUsuarios = respuesta.totalesUsuarios
                this.totalesMiembros = respuesta.totalesMiembros
                this.cargando = false
            })
        }
    }

}
</script>
